module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name,
      "onoff": _vm.onoff
    },
    on: {
      "loginFn": _vm.loginFn
    }
  }), _vm._v(" "), _c('router-view', {
    on: {
      "changeState": _vm.changest,
      "forget": _vm.forget
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btm"
  }, [_vm._v("Copyright © 2015 图灵机器人 All rights Reserved ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e363812"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 105
// module chunks = 1